var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{attrs:{"items":_vm.result,"headers":_vm.headers,"dense":""},scopedSlots:_vm._u([{key:"item.program",fn:function({ item }){return [_c('span',[_vm._v(_vm._s(_vm.formatProgram(item.program)))])]}}])}),_c('StandardChart',{staticClass:"my-3",attrs:{"input":_vm.chartData,"showTotal":true,"chartType":"bar"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }